import React from 'react';
import './ContactsPage.scss';
import { Contacts } from "../components/Contacts";
import { useCookieConsent } from "../contexts/CookieConsentContext";

const MAP_URL = 'https://yandex.by/maps/157/minsk/house/Zk4YcwBpSE0AQFtpfXVwdn1iYA==/?ll=27.579187%2C53.917114&utm_medium=mapframe&utm_source=maps&z=16.17';
const MAP_EMBED_SRC = 'https://yandex.by/map-widget/v1/?ll=27.579187%2C53.917114&mode=search&ol=geo&ouri=ymapsbm1%3A%2F%2Fgeo%3Fdata%3DCgg2NjY3ODE0MBJF0JHQtdC70LDRgNGD0YHRjCwg0JzRltC90YHQuiwg0LLRg9C70ZbRhtCwINCS0LXRgNGLINCl0LDRgNGD0LbQsNC5LCAzIgoNLqLcQRUfq1dC&z=16.17';

export function ContactsPage() {
    const { hasConsent } = useCookieConsent();

    return (
        <div className='contacts-page'>
            <div className='contacts-page__contacts'>
                <p className='contacts-page__heading'>ООО "ВояжГлобал"</p><Contacts/></div>
            <div className='contacts-page__text'>
                <p>Режим работы:</p>
                <p>пн-пт: 09:00 - 18:00</p>
                <p>сб-вскр: по предварительной записи</p>
                <p>Как нас найти:</p>
            </div>
            <div className='contacts-page__map'>
                <div style={{ position: 'relative', overflow: 'hidden' }}>
                    <a
                        href='https://yandex.by/maps/157/minsk/?utm_medium=mapframe&utm_source=maps'
                        style={{ color: '#eee', fontSize: '12px', position: 'absolute', top: '0px' }}
                    >Минск
                    </a>
                    <a
                        href={MAP_URL}
                        style={{ color: '#eee', fontSize: '12px', position: 'absolute', top: '14px' }}
                    >Улица Веры Хоружей, 3 — Яндекс Карты
                    </a>
                    {hasConsent ? (
                        <iframe
                            src={MAP_EMBED_SRC}
                            width='100%'
                            height='300px'
                            frameBorder='1'
                            allowFullScreen={true}
                            style={{ position: 'relative' }}
                            title='Карта'
                        ></iframe>
                    ) : (
                        <div className='contacts-page__map-placeholder'>
                            <p>Для отображения карты необходимо принять использование cookie.</p>
                            <a href={MAP_URL} target='_blank' rel='noopener noreferrer' className='contacts-page__map-link'>
                                Открыть карту в новом окне
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
